
import { useContext } from 'react';
import { Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom';
import { sideNavItems } from './component/Layout/Navigation';
import { AlertNotifier, AppLoader, Header, Layout, Login, SecuredRoute, Callback, PageNotFound } from './component/component';
import { CampaignSetup, EntitlementSearch, GenerateBulkReport, Home, RegistrationSearch, SearchDetailView, TransferAccounts, UpdateProtectionPlan, UserInfoSearch, ViewBulkReport, ViewReports, ManageRetailers } from './pages';
import { AppContext, AppProvider } from './store/AppProvider';
import { AppRoutes } from './utils/Constants';
import { isEmptyObj, ROLES } from './utils/Utils';
import './App.css';
import "react-multi-email/dist/style.css";
import { IdleTimeTracker } from './component/IdleTimeTracker/IdleTimeTracker';

function App() {
  return (
    <AppProvider>
      <PrimaryApp />
    </AppProvider>
  )
}

function AppLayout({ children }) {
  return (
    <>
      <IdleTimeTracker />
      <Layout children={children} />
    </>
  );
}

function PublicRoute({ children, loggedIn }) {
  if (!loggedIn)
    return children || <Outlet />;
  else
    return <Navigate to={"/"} replace />
}

function PrimaryApp() {
  const { loggedInUser: { loggedIn }, activeRole } = useContext(AppContext);
  const { pathname } = useLocation()
  const hasRole = ROLES?.[activeRole]

  const getAccessibleRoutes = () => {
    let accessRoutes = {}
    for (let item of sideNavItems) {
      const { titleRoute, role: titleRole, nestedItems } = item
      if (Boolean(titleRoute) && !isEmptyObj(titleRole)) {
        if (titleRole[hasRole]) accessRoutes[titleRoute] = true
      }
      if (nestedItems?.length) {
        for (let nestedItem of nestedItems) {
          const { subRoute, role } = nestedItem
          if (role[hasRole]) accessRoutes[subRoute] = true
        }
      }
    }
    return accessRoutes;
  }
  const accessRoutes = getAccessibleRoutes();
  return (
    <>
      {pathname !== '/callback' && <Header />}
      <AlertNotifier />
      <AppLoader />
      <Routes>
        <Route path="/" element={loggedIn ? <AppLayout children={<Home />} /> : <Login />} />
        <Route element={<PublicRoute loggedIn={loggedIn} />}>
          <Route path="/callback" element={<Callback />} />
        </Route>
        <Route element={<SecuredRoute accessRoutes={accessRoutes} />}>
          <Route element={<AppLayout />}>
            <Route path={AppRoutes.registrationSearch} element={<RegistrationSearch />} />
            <Route path={AppRoutes.entitlementSearch} element={<EntitlementSearch />} />
            <Route path={AppRoutes.userInfoSearch} element={<UserInfoSearch />} />
            <Route path={AppRoutes.searchDetails} element={<SearchDetailView />} />
            <Route path={AppRoutes.view_reports} element={<ViewReports />} />
            <Route path={AppRoutes.updateProtectionPlan} element={<UpdateProtectionPlan />} />
            <Route path={AppRoutes.transferAccount} element={<TransferAccounts />} />
            <Route path={AppRoutes.campaignSetup} element={<CampaignSetup />} />
            <Route path={AppRoutes.generateBulkReport} element={<GenerateBulkReport />} />
            <Route path={AppRoutes.viewBulkReport} element={<ViewBulkReport />} />
            <Route path={AppRoutes.manageRetailers} element={<ManageRetailers />} />
            <Route path="*" element={<PageNotFound />} />
          </Route>
        </Route>
      </Routes>
    </>
  )
}

export default App;
